var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-card"},[_c('div',{staticClass:"card-body custom-card-padding"},[_c('p',{staticClass:"stats-text dark-text"},[_vm._v(_vm._s(_vm.$t(_vm.statsText)))]),_c('h5',{staticClass:"stats-value"},[_vm._v(_vm._s(_vm.statsValue==0 ? 0 : _vm.$t(_vm.statsValue))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }